import React from 'react';
import { FadeIn } from './FadeIn';
import { Star } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    name: 'Mariana G.',
    quote: 'Ya no estamos todo el día con el celular. Siento que volví a conectar con mis hijos de verdad.',
    role: 'Mamá de 2'
  }, {
    name: 'Lucía F.',
    quote: 'Mi hijo espera con mucha ilusión abrir una nueva página. ¡Nos unió más de lo que imaginé!',
    role: 'Mamá de 1'
  }, {
    name: 'Paula M.',
    quote: "Desde que empezamos, tenemos nuestro 'momento especial'. Nos reímos muchísimo.",
    role: 'Mamá de 3'
  }];
  return <section className="py-10 bg-white" data-id="element-135">
      <div className="container mx-auto px-4" data-id="element-136">
        <FadeIn data-id="element-137">
          <h2 className="text-2xl md:text-3xl font-bold text-center text-slate-900 mb-8" data-id="element-138">
            Familias que ya están conectando ❤️
          </h2>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 max-w-6xl mx-auto" data-id="element-139">
          {testimonials.map((testimonial, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-140">
              <div className="bg-slate-50 p-6 rounded-2xl border border-slate-100 h-full flex flex-col" data-id="element-141">
                <div className="flex gap-1 mb-3" data-id="element-142">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-brand-400 text-brand-400" data-id="element-143" />)}
                </div>
                <p className="text-slate-700 text-base italic mb-4 flex-grow" data-id="element-144">
                  "{testimonial.quote}"
                </p>
                <div className="flex items-center gap-3" data-id="element-145">
                  <div className="w-10 h-10 bg-brand-200 rounded-full flex items-center justify-center text-brand-700 font-bold" data-id="element-146">
                    {testimonial.name.charAt(0)}
                  </div>
                  <div data-id="element-147">
                    <p className="font-bold text-slate-900" data-id="element-148">
                      {testimonial.name}
                    </p>
                    <p className="text-sm text-slate-500" data-id="element-149">{testimonial.role}</p>
                  </div>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}